/* Knowledge categories */
export const GET_SKILLS = "GET_SKILLS"
export const GET_SKILLS_SUCCESS = "GET_SKILLS_SUCCESS"
export const GET_SKILLS_ERROR = "GET_SKILLS_ERROR"
